import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const LegalDocumentLayout = ({ title, subtitle, children }) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#fafafa]">
      {/* Header */}
      <header className="bg-white border-b border-[#e5e5e5] sticky top-0 z-10">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <span className="logo-wordmark-text logo-wordmark-text-gradient">AXARIS™</span>
            <span className="text-[13px] text-[#86868b]">by Cloud Guidant Inc.</span>
          </div>
          <button
            onClick={() => navigate(-1)}
            className="inline-flex items-center gap-1.5 text-sm text-[#86868b] hover:text-[#1d1d1f] transition-colors group"
          >
            <svg className="w-4 h-4 group-hover:-translate-x-0.5 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            Back
          </button>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 py-8">
        <div className="bg-white rounded-2xl border border-[#e5e5e5] shadow-sm overflow-hidden">
          <div className="px-8 pt-8 pb-6 border-b border-[#f0f0f0]">
            <h1 className="text-[22px] font-semibold text-[#1d1d1f] tracking-[-0.3px]">{title}</h1>
            {subtitle && (
              <p className="text-[13px] text-[#86868b] mt-1">{subtitle}</p>
            )}
          </div>
          <div className="px-8 py-6 prose prose-sm max-w-none text-[#1d1d1f] leading-relaxed
            [&_h2]:text-[16px] [&_h2]:font-semibold [&_h2]:text-[#1d1d1f] [&_h2]:mt-6 [&_h2]:mb-3
            [&_h3]:text-[14px] [&_h3]:font-semibold [&_h3]:text-[#1d1d1f] [&_h3]:mt-5 [&_h3]:mb-2
            [&_p]:text-[13px] [&_p]:text-[#424245] [&_p]:mb-3 [&_p]:leading-[1.7]
            [&_ul]:text-[13px] [&_ul]:text-[#424245] [&_ul]:mb-3 [&_ul]:pl-5
            [&_ol]:text-[13px] [&_ol]:text-[#424245] [&_ol]:mb-3 [&_ol]:pl-5
            [&_li]:mb-1.5 [&_li]:leading-[1.7]
            [&_a]:text-[#0071e3] [&_a]:no-underline hover:[&_a]:underline
            [&_strong]:text-[#1d1d1f] [&_strong]:font-medium
            [&_.legal-caps]:uppercase [&_.legal-caps]:text-[12px] [&_.legal-caps]:font-medium [&_.legal-caps]:text-[#424245] [&_.legal-caps]:leading-[1.8]
          ">
            {children}
          </div>
        </div>

        <p className="text-center text-[12px] text-[#86868b] mt-8">
          Cloud Guidant Inc. All rights reserved.
        </p>
      </main>
    </div>
  );
};

export default LegalDocumentLayout;
